import { css } from "lit";

export const styles = css`
  .zoomable-slide,
  .scrollable-slide {
    --scroll-transition: transform var(--duration-x-long);
    --title-transition:
      font-size var(--duration-x-long), margin var(--duration-x-long),
      border-bottom var(--duration-long);
    --title-font-size: var(--font-size-6xl);
    --title-border-height: 0px;
    --scrim-transition: opacity var(--duration-long);
    --scrim-opacity: 1;
    --scrim-height: 40px;
    --scrim-top-color: rgba(0, 0, 0, 0);
    --scrim-bottom-color: var(--color-white);
    --content-translate-y: 0;
    --content-translate-x: 0;
    --content-scale: 1;
    --title-sup-size: var(--font-size-xl);
    color: var(--color-black);
    background-color: var(--color-white);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .zoomable-slide.background-class-primary,
  .scrollable-slide.background-class-primary {
    background-color: var(--slide-accent-color);
  }

  .zoomable-slide.background-class-secondary,
  .scrollable-slide.background-class-secondary {
    background-color: var(--slide-secondary-color);
  }

  .title-minimized {
    --title-font-size: var(--font-size-3xl);
    --title-border-height: 2px;
    --title-sup-size: var(--font-size-md);
  }

  ::slotted([slot="title"]) {
    border-bottom: var(--title-border-height) solid var(--color-neutral-10);
    font-size: var(--title-font-size);
    line-height: var(--line-height-tight);
    font-weight: var(--font-weight-semibold);
    transition: var(--title-transition);
    margin: var(--size-6) var(--size-5) 0;
    display: block;
  }

  .content-window {
    width: 100%;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
  }

  .zoomable-slide .content-window {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .transformed-content {
    position: absolute;
    transform: translateX(var(--content-translate-x))
      translateY(var(--content-translate-y)) scale(var(--content-scale));
    transform-origin: top center;
    transition: var(--scroll-transition);
  }

  .hidden {
    --scrim-opacity: 0;
  }

  .overflow-shadow {
    opacity: var(--scrim-opacity);
    position: absolute;
    bottom: 0;
    z-index: var(--z-10);
    width: var(--slide-default-width);
    height: var(--scrim-height);
    background: linear-gradient(
      180deg,
      var(--scrim-top-color) 0%,
      var(--scrim-bottom-color) 100%
    );
    transition: var(--scrim-transition);
  }

  .overflow-shadow-hidden {
    --scrim-opacity: 0;
  }
`;
